import { axiosInstance } from "../../../util/axios";
import { cncBaseUrlSelector, getCncAuthToken } from "../../../Api/ApiHelper";
import { formatWithPlaceholders } from "../../../util/utils";
import moment from "moment";

export const cncUpdateWOStatus = ({ woId, woStatus, customerEntry }) => {
  const baseUrl = cncBaseUrlSelector();
  const url = formatWithPlaceholders(
    `${baseUrl}${process.env.REACT_APP_CC_MODIFY_WO_STATUS_API_PATH}`,
    woId
  );
  return axiosInstance.patch(
    url,
    { cc_status: woStatus, customer_entry: customerEntry },
    {
      headers: {
        Authorization: `Bearer ${getCncAuthToken()}`,
        Accept: "application/json",
      },
    }
  );
};

export const cncCreateWeboReport = ({
  woNo,
  customerEntry,
  pickup_store_location,
}) => {
  const baseUrl = cncBaseUrlSelector();
  const url = formatWithPlaceholders(
    `${baseUrl}${process.env.REACT_APP_CC_CREATE_WO_REPORT_API_PATH}`
  );
  return axiosInstance.post(
    url,
    {
      weborder_number: woNo,
      customer_entry: customerEntry,
      customer_arrived_dt: moment().utc().format(),
      pickup_store_location,
    },
    {
      headers: {
        Authorization: `Bearer ${getCncAuthToken()}`,
        Accept: "application/json",
      },
    }
  );
};
